export default function strippedString(str: string) {
  str = str.replace(/(<([^>]+)>)/gi, '')
  return str
}
